export default __webpack_public_path__ + "doorbell_tahoe.8cd5994b.png";